module.exports = __webpack_public_path__ + "img/GongXin.3c00f105.png";